import React from "react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Icon, Footer } from "../components";
import routes from "../constants/routes";
import { Typography, Card } from "@material-ui/core";
import TopBar from "../components/navigation/Header/TopBar";

const styles = (theme: Theme) =>
  createStyles({
    content: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    icon: {
      marginRight: theme.spacing(1)
    },
    iconWrapper: {
      alignItems: "center",
      color: theme.palette.primary.light,
      display: "flex",
      marginTop: theme.spacing(1)
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    },
    root: {
      display: "flex",
      flexDirection: "column",
      height: "100vh"
    },
    subtitle: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    supportWrapper: {
      padding: theme.spacing(4)
    }
  });

type State = {};

type Props = {
  authenticated: boolean;
  classes?: any;
};

class Support extends React.Component<Props, State> {
  render() {
    const { authenticated, classes } = this.props;
    return (
      <div className={classes.root}>
        {!authenticated && <TopBar />}
        <div className={classes.content}>
          <Card className={classes.supportWrapper}>
            <Typography color="primary" variant="h2">
              {routes.SUPPORT.label}
            </Typography>
            <Typography
              className={classes.subtitle}
              color="textSecondary"
              variant="h5"
            >
              Has something gone wrong?
            </Typography>
            <Typography color="textSecondary">
              For help using this application please contact Medicines Control
            </Typography>
            <div className={classes.iconWrapper}>
              <Icon className={classes.icon} color="inherit" name="call" />
              <Typography color="primary" variant="subtitle1">
                04 816 2444
              </Typography>
            </div>
            <div className={classes.iconWrapper}>
              <Icon className={classes.icon} color="inherit" name="mail" />
              <a
                className={classes.link}
                href={`mailto:${routes.MEDICINE_CONTROL_EMAIL}`}
              >
                <Typography color="inherit" variant="subtitle1">
                  {routes.MEDICINE_CONTROL_EMAIL}
                </Typography>
              </a>
            </div>
          </Card>
        </div>
        {!authenticated && (
          <Footer
            links={[
              { url: routes.HOME.url, label: "Home" },
              { url: routes.TERMS.url, label: routes.TERMS.label }
            ]}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Support);
